import {translationChunksConfig} from '@spartacus/assets';
import {CartNotEmptyGuard, CheckoutAuthGuard} from '@spartacus/checkout/base/components';
import {CheckoutStepType} from '@spartacus/checkout/base/root';
import {translations} from '../../translations/translations';
import {DcpReviewSubmitComponent} from '../checkout/dcp-review-submit/dcp-review-submit.component';
import {DigitalNativeCheckoutComponent} from '../digital-native-checkout/digital-native-checkout.component';
import {DcpStorefrontConfig} from './AppConfig';

export const CommerceConfig: DcpStorefrontConfig = {
  backend: {
    occ: {
      endpoints: {
        /**
         * sonar indicates that we are not supposed to use interpolation while not inside a template string,
         * so we are disabling sonar checks for these lines as this is configuration for spartacus
         */
        product: {
          default:
            'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),vendor(FULL)',  // NOSONAR
          list:
            'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),vendor(FULL)', // NOSONAR
          details:
            'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),vendor(FULL)', // NOSONAR
          attributes: 'products/${productCode}?fields=classifications', // NOSONAR
          variants:
            'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),vendor(FULL)', // NOSONAR
          scope: 'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(FULL),vendor(FULL)', // NOSONAR
        },
        cart:
          'users/${userId}/carts/${cartId}?fields=DEFAULT,purchaseOrderNumber,potentialProductPromotions,appliedProductPromotions(DEFAULT),potentialOrderPromotions,appliedOrderPromotions(DEFAULT),entries(totalPrice(formattedValue),product(DEFAULT,images(FULL),stock(FULL),vendor(FULL,address(FULL)),supplierAlternativeAID),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue,value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user', // NOSONAR
        addToCart: 'users/${userId}/carts/${cartId}/entries', // NOSONAR
        cartPurchaseOrderNumber: 'users/${userId}/carts/${cartId}/purchaseOrderNumber', // NOSONAR
        productSearch:
          'products/search?fields=products(code,name,summary,price(FULL),images(DEFAULT),stock(FULL),averageRating,classifications,transactionTypes,trial,variantOptions),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch', // NOSONAR
        // As the order is placed using the cart-decorator kyma service, placeOrder is deprecated.
        placeOrder: 'users/${userId}/orders?fields=FULL,purchaseOrderNumber', // NOSONAR
        user: 'users/${userId}?fields=BASIC,defaultAddress(FULL),defaultUnitAddress(FULL),scimUserId,json', // NOSONAR
        carts:
          'users/${userId}/carts?fields=carts(DEFAULT,potentialProductPromotions,appliedProductPromotions(DEFAULT),potentialOrderPromotions,appliedOrderPromotions(DEFAULT),entries(totalPrice(formattedValue),product(images(FULL),stock(FULL),vendor(FULL,address(FULL)),supplierAlternativeAID),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue,value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),saveTime,user,name)', // NOSONAR
        transactionTypes: '/config/transactionTypes',
        setCartPaymentType: 'users/${userId}/carts/${cartId}/paymenttype?fields=DEFAULT,invalid,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL),vendor(FULL,address(FULL)),supplierAlternativeAID),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue,value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),saveTime,user,name,entryGroups(FULL)', // NOSONAR
      } as any,
    },
  },
  authentication: {
    client_secret: '',
    tokenEndpoint: '/oauth2/token',
    revokeEndpoint: '/oauth2/revoke',
    loginUrl: '/oauth2/authorize',
    logoutUrl: '/oauth2/logout',
    OAuthLibConfig: {
      oidc: true,
      responseType: 'code',
      requestAccessToken: true,
      scope: 'openid profile email offline_access',
      useSilentRefresh: false,
      disablePKCE: false
    },
  },
  i18n: {
    resources: translations,
    chunks: {
      ...translationChunksConfig,
      checkout: [
        'checkout',
        'checkoutAddress',
        'checkoutOrderConfirmation',
        'checkoutReview',
        'checkoutShipping',
        'checkoutProgress',
        'checkoutPO',
      ],
    },
    fallbackLang: 'en',
  },
  features: {
    level: '5.0',
  },
  breakpoints: {
    xs: 767,
    sm: 979,
    md: 1299,
    lg: 1599,
    // xl: is 1600 and up
  },
  checkout: {
    // You must specify all of the steps (this configuration is not merged with the default one)
    steps: [
      {
        id: 'CheckoutDataEntry',
        name: 'checkoutProgress.dataEntry',
        routeName: 'checkoutDataEntry',
        type: [CheckoutStepType.PAYMENT_DETAILS],
      },
      {
        id: 'CheckoutReviewOrder',
        name: 'checkoutProgress.reviewOrder',
        routeName: 'checkoutReviewOrder',
        type: [CheckoutStepType.REVIEW_ORDER],
      },
    ],
  },
  cmsComponents: {
    CheckoutReviewOrder: {
      component: DcpReviewSubmitComponent,
      guards: [
        CheckoutAuthGuard,
        CartNotEmptyGuard,
      ],
    },
    CheckoutDataEntry: {
      component: DigitalNativeCheckoutComponent,
      guards: [
        CheckoutAuthGuard,
        CartNotEmptyGuard,
      ],
    }
  },
};
